<template>
  <SearchableDropdown
    v-model="computedValue"
    class="form-selector form__searchable-dropdown"
    :config="countryValueConfig"
    v-bind="{...$props, ...$attrs}"
  />
</template>

<script>
import SearchableDropdown from '../SearchableDropdown/SearchableDropdown.vue';
import { GET_COUNTRIES } from '@/modules/info/store/actionTypes';
import { mapActions, mapState } from 'vuex';
export default {
  components: { SearchableDropdown },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    required: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Object],
      default: () => undefined
    },
    placeholder: {
      type: String,
      default: ''
    },
    full: {
      type: Boolean
    },
    availableCountries: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapState('info', {
      countries(state) {
        
        return Array.from(state.countries, ({ name, countryCode, ...rest }) => ({
          label: name,
          value: countryCode,
          ...(this.full ? rest : {})
        })).sort((a, b) => (a.label > b.label ? 1 : a.label < b.label ? -1 : 0));
      }
    }),
    /** @type {() => {
     * options: unknown[];
     * placeholder: VueI18n.TranslateResult;
     * getOptionKey: (option: any) => any;
     * getOptionLabel: (option: any) => any;
     * clearable: boolean;
     *  }}
     */
    countryValueConfig() {
      return {
        options: this.filteredCountries,
        placeholder: this.placeholder,
        getOptionKey: r => r.value,
        getOptionLabel: r => r.label,
        clearable: false
      };
    },

    /**
     * Used for binding the v-model
     */
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('change', value);
      }
    },

    filteredCountries() {
      if (this.availableCountries) {
        const availableCountriesSet = new Set(this.availableCountries.map(country => country.value));
        return this.countries.filter(country => availableCountriesSet.has(country.value));
      }
      return this.countries;
    },
  },

  // Load the list of countries on first mount
  async beforeMount() {
    if(!this.countries?.length) {
      this[GET_COUNTRIES]();
    }
  },
  methods: {
    ...mapActions('info', [
      GET_COUNTRIES
    ])
  }
};
</script>